import { ApiClientInterface } from './clients';
import { Money, Reservation } from './models';

export class ReservationManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public getAll(): Promise<Reservation[]> {
    return this.apiClient.get('/');
  }

  public getByProject(projectUuid: string): Promise<Reservation | null> {
    return this.apiClient.get(`/${projectUuid}`);
  }

  public create(projectUuid: string, money: Money): Promise<Reservation> {
    return this.apiClient.post(`/${projectUuid}`, { money });
  }
}
